export default class Offer {

  id = '';
  createdAt = '';
  name = '';
  client = '';
  customer = '';
  tags = [];
  regions = '';
  excludedElevators = [];
  category = '';
  budget = '';
  provision = '';
  dateStart = '';
  dateEnd = '';
  playouts = '';
  discount = '';

  constructor() {
  }
}